export class MaintenanceRoutineSupplyImportModel {
    counter: number = 0;
    companyId: number = 0;
    articleCode: number = 0;
    supplyCode: number = 0;
    quantityEachUse: number = 0;
    maintenancePlan1: number = 0;
    maintenancePlan2: number = 0;
    maintenancePlan3: number = 0;
    maintenancePlan4: number = 0;
    maintenancePlan5: number = 0;
    maintenancePlan6: number = 0;
    maintenancePlan7: number = 0;
    swHomologus: boolean = false;
    homologusCode: number | null = null;

    constructor(
        counter: number,
        companyId: number,
        articleCode: number,
        supplyCode: number,
        quantityEachUse: number,
        maintenancePlan1: number,
        maintenancePlan2: number,
        maintenancePlan3: number,
        maintenancePlan4: number,
        maintenancePlan5: number,
        maintenancePlan6: number,
        maintenancePlan7: number,
        swHomologus: boolean,
        homologusCode: number | null
    ) {
        this.counter = counter;
        this.companyId = companyId;
        this.articleCode = articleCode;
        this.supplyCode = supplyCode;
        this.quantityEachUse = quantityEachUse;
        this.maintenancePlan1 = maintenancePlan1;
        this.maintenancePlan2 = maintenancePlan2;
        this.maintenancePlan3 = maintenancePlan3;
        this.maintenancePlan4 = maintenancePlan4;
        this.maintenancePlan5 = maintenancePlan5;
        this.maintenancePlan6 = maintenancePlan6;
        this.maintenancePlan7 = maintenancePlan7;
        this.swHomologus = swHomologus;
        this.homologusCode = homologusCode;
    }
}